import { Dice1, Dice2, Dice3, Dice4, Dice5, Dice6 } from "lucide-react";
import { useEffect, useState } from "react";
import styles from "./dice.module.scss";
import classNames from "classnames/bind";
import { getRandInt } from "lib/numberUtils";

const classNameBuilder = classNames.bind(styles);

export const diceMap = {
  1: Dice1,
  2: Dice2,
  3: Dice3,
  4: Dice4,
  5: Dice5,
  6: Dice6,
};

const MAX_DICE_VALUE = 6;
const MIN_DICE_VALUE = 1;

export const Dice = ({
  value: valueProp = MAX_DICE_VALUE,
  hovered,
  rollInterval = 100,
  animated,
}) => {
  const [value, setValue] = useState(valueProp);
  useEffect(() => {
    if (hovered || animated) {
      let prevValue = value;
      const id = window.setInterval(() => {
        let newValue;
        do {
          newValue = getRandInt(MAX_DICE_VALUE, MIN_DICE_VALUE);
        } while (newValue === prevValue);
        prevValue = newValue;
        setValue(newValue);
      }, rollInterval);
      return () => window.clearInterval(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hovered, animated, rollInterval]);
  const DiceIcon = diceMap[value];
  return (
    <div className={classNameBuilder("container", { hovered })}>
      <div className={classNameBuilder("dice", { hovered })}>
        <DiceIcon />
      </div>
    </div>
  );
};
